import { Col, Container, Row, Stack } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import React from 'react'
import { IntegrationServiceId } from '../../../../common/integrations'
import { IntegrationIcon } from '../../../../components/IntegrationIcon'

export const MeetIntegrationRow = () => {
  return (
    <Container className='p-3 p-md-0 py-md-3 integration-container'>
      <Row className='d-flex align-items-start justify-content-between'>
        <Col>
          <Stack direction='horizontal' className='gap-4 pb-4 pb-md-0'>
            <div className='rounded py-1 px-1 zocks-bg-color-gray-100'>
              <IntegrationIcon serviceId={IntegrationServiceId.MEET} width={48} height={48} />
            </div>
            <div>
              <h6>Google Meet</h6>
              <div>
                Connect your calendar or{' '}
                <Link to='/workspace/upcoming' className='zocks-text-primary'>
                  invite
                </Link>{' '}
                the assistant to your meetings.
              </div>
            </div>
          </Stack>
        </Col>
      </Row>
    </Container>
  )
}
